import React from "react";
import { connect } from "react-redux";
import {
  AppBar,
  IconButton,
  Icon
} from "@material-ui/core";
import MailIcon from "@material-ui/icons/Mail";

const HeaderContactos = props => {

  return (
    <AppBar position="static">
      <div className="blue darken-4">
        <h6 style={{ float: "left", padding: "5px 10px" }}>
          Contactos
        </h6>
        <div style={{ float: "right" }}>
          <IconButton color="inherit">
              <Icon>add</Icon>
          </IconButton>
          <IconButton color="inherit">
            <MailIcon />
          </IconButton>
        </div>
      </div>
    </AppBar>
  );
};

const mapStateToProps = state => {
  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile
  };
};

export default connect(mapStateToProps)(HeaderContactos);
